import React, { useState } from "react";
import { Button, Card, Col, Row, Stack } from "react-bootstrap";
import { postProgram } from "../../../services/httpClient";
import Input from "../../ui/Input";
import ProgramCard from "./ProgramCard";
import { unsavedChanges } from "../../../App";

interface ProgramsState {
  programs: any;
  getPrograms: any;
  setOrgToSave: any;
  setErrMessage: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
  showAddProgram: boolean;
  setShowAddProgram: (value: boolean) => void;
  onEdit: (programId: any) => void;
}

const Programs = ({
  programs,
  getPrograms,
  setOrgToSave,
  setErrMessage,
  setShowToast,
  setToastText,
  setToastBody,
  showAddProgram,
  setShowAddProgram,
  onEdit,
}: ProgramsState) => {
  const [newProgram, setNewProgram] = useState<string>("");

  const onClickAddProgram = () => {
    setShowAddProgram(true);
  };

  const updateNewProgram = (e: any) => {
    setNewProgram(e.target.value);
    unsavedChanges.value = true;
    setOrgToSave(true);
  };

  const onClickSaveProgram = (isDone: boolean = false) => {
    const newProg = {
      name: newProgram,
    };

    setErrMessage("");

    postProgram(newProg)
      .then((res: any) => {
        setShowToast(true);
        setToastText("Program Created");
        setToastBody(newProgram);
        setNewProgram("");
        unsavedChanges.value = false;
        setOrgToSave(false);
        if (isDone) {
          setShowAddProgram(false);
        }
        getPrograms(true);
      })
      .catch((err: any) => {
        setErrMessage(err?.response?.data?.msg);
        window.scrollTo({
          top: 0,
          behavior: "auto",
        });
      });
  };

  const onClickCancelAddProgram = () => {
    setErrMessage("");
    setShowAddProgram(false);
    setNewProgram("");
    unsavedChanges.value = false;
    setOrgToSave(false);
  };

  const renderAddProgram = () => {
    return (
      <>
        <Row className="align-items-center my-3">
          <Col xs={12}>
            <Input
              label="Program"
              type="text"
              value={newProgram}
              onUpdate={(e: any) => updateNewProgram(e)}
              hasFocus={true}
              required={true}
            />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col xs={12} lg={8}>
            <Stack direction="horizontal" gap={3}>
              <Button
                className="app-secondary-color button"
                disabled={!newProgram}
                onClick={() => onClickSaveProgram(false)}
              >
                Save and Add Another
              </Button>
              <div className="vr" />
              <Button
                className="app-secondary-color button"
                disabled={!newProgram}
                onClick={() => onClickSaveProgram(true)}
              >
                Save and Close
              </Button>
              <div className="vr" />
              <Button
                className="app-primary-color button"
                onClick={() => onClickCancelAddProgram()}
              >
                Cancel
              </Button>
            </Stack>
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      {programs.length === 0 ? (
        <>
          <p className="mt-2">No Program Records</p>
          {showAddProgram && renderAddProgram()}
        </>
      ) : (
        <>
          {showAddProgram && renderAddProgram()}
          <Row>
            <Col xs={12}>
              <Stack gap={3}>
                {programs?.map((p: any, index: number) => (
                  <Card key={index} className="p-3 bg-light">
                    <ProgramCard
                      program={p}
                      getItems={getPrograms}
                      onEdit={onEdit}
                      setErrMessage={setErrMessage}
                      setShowToast={setShowToast}
                      setToastText={setToastText}
                      setToastBody={setToastBody}
                    />
                  </Card>
                ))}
              </Stack>
            </Col>
          </Row>
        </>
      )}
      <Row className="mb-5"></Row>
    </>
  );
};

export default Programs;
